import { Box, CircularProgress, Grid, Typography } from "components/common";
import { useEffect } from "react";
import useProductsFunctions from "../../ts/useProductsFunctions";
import ProductCard from "./product-card";
import { useLocation } from "react-router-dom";
import { searchClient } from "utils/searchClient";

export default function ProductList() {
  const { loading, data, lastElementRef, research } = useProductsFunctions();
  const location = useLocation();

  useEffect(() => {
    research();
  }, [location.search, location.pathname]);

  return (
    <Grid container spacing={{ xl: 4, lg: 3, md: 2 }}>
      {loading && data.length === 0 ? (
        <Box width="100%" textAlign="center">
          <CircularProgress />
        </Box>
      ) : data.length === 0 ? (
        <Box flex={1}>
          <Typography variant="h5" textAlign="center">
            No Products Found
          </Typography>
        </Box>
      ) : (
        data?.map((product: any, index: number) => (
          <ProductCard
            key={index}
            data={product}
            ref={index === data.length - 1 ? lastElementRef : null}
          />
        ))
      )}
      {loading && data.length > 0 && (
        <Box width="100%" textAlign="center">
          <CircularProgress />
        </Box>
      )}
    </Grid>
  );
}
